module.exports = __webpack_public_path__ + "static/media/adobe.006bbb29.svg";